import { useTranslation } from "react-i18next";
import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFLookupVatType } from "../../../Shared/NewForms/NFLookupVatType";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";

export const ProductionAndSalesWithPaymentsAdvances = () => {
    const { t } = useTranslation();

    return (
        <>
                <NFormTable fieldArray={"advances"}>
                    <NFIntInput
                        fieldName="paymentOffset"
                        title={t("Payment Offset")}
                    />
                    <NFLookupAccount
                        title={t("account")}
                        fieldName="accountId"
                    />
                    <NFIntInput title={t("ammount")} fieldName="amount" />
                    <NFLookupVatType
                        title={t("VAT Account")}
                        fieldName="vatAccountId"
                    />
                    <NFIntInput
                        title={t("advancesVat")}
                        fieldName="advancesVat"
                    />
                </NFormTable>
        </>
    );
};
